// The two v3 key-event field predicates, kept apart on purpose — they are not the same rule.
//
// The TABLE rule (v3 `format.js mapColumns:2052-2064`) is the one that decided which columns
// `showKeyEvents: true` auto-selected, and it matched the three prefixes the catalog labels as key
// events (GA4 `key_events_*`, Hardal `hardal_event_*`, MMP `mmp_key_events*`) — anchored, because
// it ran per column while resolving that column's own labelling branch.
//
// The CHART rule (v3 `OrphexDashboardChartArea.vue:183-187`) filtered an already-flat metric list
// with unanchored `includes`, and additionally kept GA4's `mp_conversions`. That is looser on both
// counts (it catches `attr_key_event_…`-style derivations and the `_value` variants), and the
// looseness is load-bearing: the trendline plots whatever conversion-ish metric the partition
// carries, whereas the table selection must not silently tick a column the customize panel then
// shows under a non-key-event header.

/** v3 `mapColumns` — the prefixes whose columns render with a key-event label. */
export function isKeyEventField(field: string): boolean {
  return (
    field.startsWith('key_events_') ||
    field.startsWith('hardal_event_') ||
    field.startsWith('mmp_key_events')
  )
}

/** v3 `OrphexDashboardChartArea` — the looser trendline rule, `mp_conversions` included. */
export function isKeyEventChartField(field: string): boolean {
  return field.includes('key_event') || field.includes('keyevents') || field === 'mp_conversions'
}
